import { useEffect, useState } from 'react';
import { clientiApi } from '../api';
import Modal from '../components/Modal';
import ClienteAutocomplete from '../components/ClienteAutocomplete';

const empty = { nome: '', ragione_sociale: '', email: '', telefono: '', indirizzo: '', piva: '', codice_fiscale: '', note: '' };

export default function Clienti() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () => clientiApi.list({ search }).then(setRows);
  useEffect(() => { load(); }, [search]);

  const openNew = () => { setForm(empty); setModal({ mode: 'new' }); };
  const openEdit = (r) => { setForm(r); setModal({ mode: 'edit', id: r.id }); };

  const save = async () => {
    if (!form.ragione_sociale?.trim()) return alert('La Ragione Sociale è obbligatoria');
    setSaving(true);
    try {
      if (modal.mode === 'new') await clientiApi.create(form);
      else await clientiApi.update(modal.id, form);
      setModal(null);
      load();
    } catch (e) { alert(e); } finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!confirm('Eliminare questo cliente?')) return;
    await clientiApi.delete(id);
    load();
  };

  const f = (k) => ({ value: form[k] || '', onChange: e => setForm(p => ({ ...p, [k]: e.target.value })) });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="page-title">Clienti</h1>
        <button className="btn-primary" onClick={openNew}>+ Nuovo cliente</button>
      </div>
      <input className="input max-w-xs" placeholder="Cerca..." value={search} onChange={e => setSearch(e.target.value)} />

      <div className="card p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr className="text-left text-xs text-gray-500">
              <th className="px-4 py-3">Ragione Sociale</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Telefono</th>
              <th className="px-4 py-3">P.IVA</th>
              <th className="px-4 py-3">Offerte</th>
              <th className="px-4 py-3">Commesse</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-gray-400">Nessun cliente</td></tr>
            )}
            {rows.map(r => (
              <tr key={r.id} className="border-b last:border-0 hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="font-medium text-gray-900">{r.ragione_sociale || r.nome}</div>
                  {r.ragione_sociale && r.nome && r.ragione_sociale !== r.nome && (
                    <div className="text-xs text-gray-400">{r.nome}</div>
                  )}
                </td>
                <td className="px-4 py-3 text-gray-600">{r.email || '—'}</td>
                <td className="px-4 py-3 text-gray-600">{r.telefono || '—'}</td>
                <td className="px-4 py-3 text-gray-500">{r.piva || '—'}</td>
                <td className="px-4 py-3 text-center">{r.n_offerte}</td>
                <td className="px-4 py-3 text-center">{r.n_commesse}</td>
                <td className="px-4 py-3 flex gap-2 justify-end">
                  <button className="btn-secondary btn-sm" onClick={() => openEdit(r)}>Modifica</button>
                  <button className="btn-danger btn-sm" onClick={() => del(r.id)}>Elimina</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={modal.mode === 'new' ? 'Nuovo cliente' : 'Modifica cliente'} onClose={() => setModal(null)}>
          <div className="grid grid-cols-2 gap-4">

            {/* Ragione Sociale con autocomplete — primo campo, obbligatorio */}
            <div className="col-span-2">
              <label className="label">Ragione Sociale *</label>
              <ClienteAutocomplete
                value={form.ragione_sociale || ''}
                onChange={val => setForm(p => ({ ...p, ragione_sociale: val }))}
                onSelect={c => {
                  if (modal.mode === 'new') {
                    alert(`Attenzione: "${c.ragione_sociale || c.nome}" è già presente in archivio. Aprilo da Clienti per modificarlo.`);
                    setForm(p => ({ ...p, ragione_sociale: c.ragione_sociale || c.nome }));
                  } else {
                    setForm(p => ({ ...p, ragione_sociale: c.ragione_sociale || c.nome }));
                  }
                }}
                placeholder="Es. Sinthema S.r.l."
              />
            </div>

            <div className="col-span-2">
              <label className="label">Nome breve / Alias</label>
              <input className="input" placeholder="Es. Sinthema (facoltativo)" {...f('nome')} />
            </div>

            <div><label className="label">P.IVA</label><input className="input" {...f('piva')} /></div>
            <div><label className="label">Codice Fiscale</label><input className="input" {...f('codice_fiscale')} /></div>
            <div><label className="label">Email</label><input className="input" type="email" {...f('email')} /></div>
            <div><label className="label">Telefono</label><input className="input" {...f('telefono')} /></div>
            <div className="col-span-2"><label className="label">Indirizzo</label><input className="input" {...f('indirizzo')} /></div>
            <div className="col-span-2"><label className="label">Note</label><textarea className="input" rows={2} {...f('note')} /></div>
          </div>
          <div className="flex justify-end gap-2 mt-5">
            <button className="btn-secondary" onClick={() => setModal(null)}>Annulla</button>
            <button className="btn-primary" onClick={save} disabled={saving}>{saving ? 'Salvo...' : 'Salva'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
